import { states, counties } from '../../mixins/states';
export default {
    namespaced: true,
    state: {
        user: null,
        programs: [],
        states,
        counties,
        permissions: {
            auditor: false,
            pm: false,
            manager: false,
            admin: false,
            root: false,
            household: false,
            debtor: false,
            processor: false,
        },
        partners: [],
        usingScreenReader: false,
        env: {
            APPLY_OPEN: window.Laravel.env.APPLY_OPEN,
            ALT_OPEN: window.Laravel.env.ALT_OPEN,
            ALT_WAITLIST: window.Laravel.env.ALT_WAITLIST,
            PROGRAM_NAME: window.Laravel.env.PROGRAM_NAME,
            PROGRAM_URL: window.Laravel.env.PROGRAM_URL,
            AGENCY_NAME: window.Laravel.env.AGENCY_NAME,
            AGENCY_BRAND_GUIDELINE: window.Laravel.env.AGENCY_BRAND_GUIDELINE,
            AGENCY_SHORT_NAME: window.Laravel.env.AGENCY_SHORT_NAME,
            AGENCY_SITE: window.Laravel.env.AGENCY_SITE,
            FAVICON: window.Laravel.env.FAVICON,
            PRIMARY_COLOR: window.Laravel.env.PRIMARY_COLOR,
            PUBLIC_PHONE: window.Laravel.env.PUBLIC_PHONE,
            PUBLIC_EMAIL: window.Laravel.env.PUBLIC_EMAIL,
            PUBLIC_FAX: window.Laravel.env.PUBLIC_FAX,
            PUBLIC_STREET: window.Laravel.env.PUBLIC_STREET,
            PUBLIC_CITY: window.Laravel.env.PUBLIC_CITY,
            PUBLIC_STATE: window.Laravel.env.PUBLIC_STATE,
            PUBLIC_ZIP: window.Laravel.env.PUBLIC_ZIP,
            PUBLIC_LOGO: window.Laravel.env.PUBLIC_LOGO,
            USE_LAYOUT_SET: window.Laravel.env.USE_LAYOUT_SET,
            USE_ZOHO: window.Laravel.env.USE_ZOHO,
            WAITLIST: window.Laravel.env.WAITLIST,
            GOOGLE_API_KEY: window.Laravel.env.GOOGLE_JAVASCRIPT_API_KEY,
            AUTH_TYPE: window.Laravel.env.AUTH_TYPE,
            LANG_KEY: window.Laravel.env.LANG_KEY,
            PARTNER_ON_DASHBOARD: Number(window.Laravel.env.PARTNER_ON_DASHBOARD),
            WATERFALL_SITE: Number(window.Laravel.env.WATERFALL_SITE),
            PROPERTY_DEFAULT_PROGRAM_ID: window.Laravel.env.DEFAULT_PROGRAM_ID,
            SHOW_DEFAULT_PROGRAM_PROPERTY: window.Laravel.env.SHOW_DEFAULT_PROGRAM_PROPERTY,
            USE_EVICTION_IN_PROCESS: window.Laravel.env.USE_EVICTION_IN_PROCESS,
            SHOW_APP_PRINT_BUTTON: window.Laravel.env.SHOW_APP_PRINT_BUTTON,
            HELP_QUALIFY_LINK: window.Laravel.env.HELP_QUALIFY_LINK,
            SHOW_CONTACT_USERNAME: window.Laravel.env.SHOW_CONTACT_USERNAME,
            MINIMUM_ROLE_ADD_PROPERTY: window.Laravel.env.MINIMUM_ROLE_ADD_PROPERTY,MINIMUM_ROLE_PROPERTY_CONTACT: window.Laravel.env.MINIMUM_ROLE_PROPERTY_CONTACT,
        }
    },
    mutations: {
        SET_USER: (state, payload) => state.user = payload.user,
        SET_PROGRAMS: (state, payload) => state.programs = payload,
        SET_PERMISSIONS: (state, payload) => state.permissions = payload.permissions,
        SET_STATES: (state, payload) => null,
        SET_COUNTIES: (state, payload) => null,
        SET_PARTNERS: (state, payload) => state.partners = payload.partners,
        SET_USING_SCREENREADER: (state, payload) => state.usingScreenReader = payload,
    },
    actions: {
        fetchUser({commit}) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/hope/me`).then(res => {
                    commit('SET_USER', { user: res.data.user });
                    commit('SET_PERMISSIONS', { permissions: res.data.permissions });
                    commit('SET_STATES', { states: res.data.states });
                    commit('SET_COUNTIES', { counties: res.data.counties });
                    resolve(res.data)
                }).catch(e => {
                    reject(e)
                })
            });
        },
        getUser({commit}) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/hope/me`).then(res => {
                    commit('SET_USER', { user: res.data.user });
                    commit('SET_PERMISSIONS', { permissions: res.data.permissions });
                    commit('SET_STATES', { states: res.data.states });
                    commit('SET_COUNTIES', { counties: res.data.counties });
                    resolve(res.data)
                }).catch(e => {
                    reject(e)
                })
            });
        },
        getPartners({commit}) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/hope/field-partners`).then(res => {
                    commit('SET_PARTNERS', { partners: res.data.partners });
                    resolve(res.data)
                }).catch(e => {
                    reject(e)
                })
            });
        },
        setUser({commit}, payload) {
            commit('SET_USER', payload);
        },

        addFieldPartner ({ commit, state }, param) {
            return new Promise((resolve, reject) => {
              axios
                .post(`/api/hope/add-field-partner`, param)
                .then((res) => {
                  resolve(res.data)
                })
                .catch((error) => {
                  reject(error)
                })
            })
        },

        setUsingScreenReader({commit}, payload) {
            commit('SET_USING_SCREENREADER', payload)
        },
    },
    getters: {
        user: (state) => state.user,
        permissions: (state) => state.permissions,
        usingScreenReader: (state) => state.usingScreenReader,
    }
}
